export function converDateTimeToISOFormat (dateStr) {
  const [day, month, yearAndTime] = dateStr?.split('/')
  const [year, time] = yearAndTime?.split(' ')
  return `${year}-${month}-${day}T${time}Z`
}

export function converCLaimDateTimeToISOFormat (dateStr) {
  return new Date(dateStr).toISOString()
}
